import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

import type { DataTableColumn } from '../common';

/**
 * O que a coluna do item mostra de cada linha: o nome, a descrição, as marcas ao lado do nome
 * e uma nota abaixo da descrição.
 */
export interface ConteudoDoItem<L> {
  nome: (linha: L) => string;
  descricao?: (linha: L) => string | null | undefined;
  marcas?: (linha: L) => React.ReactNode;
  nota?: (linha: L) => React.ReactNode;
}

/** A primeira coluna das tabelas de aplicação, com o nome do item no título. */
export function colunaDoItem<L>(rotuloDoItem: string, { nome, descricao, marcas, nota }: ConteudoDoItem<L>): DataTableColumn<L> {
  return {
    id: 'item',
    label: rotuloDoItem.replace(/^./, (c) => c.toUpperCase()),
    primary: true,
    render: (linha) => {
      const texto = descricao?.(linha);
      return (
        <Box>
          <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap>
            <Typography variant="body2" fontWeight={600}>
              {nome(linha)}
            </Typography>
            {marcas?.(linha)}
          </Stack>
          {texto && (
            <Typography variant="body2" color="text.secondary">
              {texto}
            </Typography>
          )}
          {nota?.(linha)}
        </Box>
      );
    },
  };
}
